import { WorkflowOrganisationAccessLevel } from "../../constants";

export const hasWorkflowOrganisationAccessLevel = (
  targetAccessLevel: WorkflowOrganisationAccessLevel,
  userAccessLevel?: WorkflowOrganisationAccessLevel
): boolean => {
  if (userAccessLevel === undefined) return false;

  const accessLevels = {
    [WorkflowOrganisationAccessLevel.Owner]: [
      WorkflowOrganisationAccessLevel.Owner,
      WorkflowOrganisationAccessLevel.Author,
      WorkflowOrganisationAccessLevel.Contributor,
      WorkflowOrganisationAccessLevel.User,
      WorkflowOrganisationAccessLevel.Viewer,
    ],
    [WorkflowOrganisationAccessLevel.Author]: [
      WorkflowOrganisationAccessLevel.Author,
      WorkflowOrganisationAccessLevel.Contributor,
      WorkflowOrganisationAccessLevel.User,
      WorkflowOrganisationAccessLevel.Viewer,
    ],
    [WorkflowOrganisationAccessLevel.Contributor]: [
      WorkflowOrganisationAccessLevel.Contributor,
      WorkflowOrganisationAccessLevel.User,
      WorkflowOrganisationAccessLevel.Viewer,
    ],
    [WorkflowOrganisationAccessLevel.User]: [
      WorkflowOrganisationAccessLevel.User,
      WorkflowOrganisationAccessLevel.Viewer,
    ],
    [WorkflowOrganisationAccessLevel.Viewer]: [WorkflowOrganisationAccessLevel.Viewer],
  };

  return accessLevels[userAccessLevel]?.includes(targetAccessLevel);
};
